
export const recadastramentoViewRouter = [
  {
    path: "/" + process.env.VUE_APP_BASE_URL + "/recadView",
    name: "RECADVIEW_MENU",
    component: () => import("@/paginas/recadastramentoList/listRecadastros.vue"),
    meta: {
      auth: ['GESTAOPESSOA_MENU', 'RECADVIEW_MENU'],
    }
  },
  {
    path: "/" + process.env.VUE_APP_BASE_URL + "/recadView/:id",
    component: () => import("@/paginas/recadastramentoView/recadastramento.vue"),
    children: [
      {
        path: "dados-pessoais",
        name: "RECADVIEW_DADOS_PESSOAIS_VIEW",
        component: () => import("@/paginas/recadastramentoView/dadospessoais.vue"),
        meta: {
          auth: ['GESTAOPESSOA_MENU', 'RECADVIEW_MENU'],
        }
      },
      {
        path: "documentos",
        name: "RECADVIEW_DOCUMENTOS_PESSOAIS_VIEW",
        component: () => import("@/paginas/recadastramentoView/documentosPessoais.vue"),
        meta: {
          auth: ['GESTAOPESSOA_MENU', 'RECADVIEW_MENU'],
        }
      },
      {
        path: "endereco",
        name: "RECADVIEW_ENDERECO_VIEW",
        component: () => import("@/paginas/recadastramentoView/endereco.vue"),
        meta: {
          auth: ['GESTAOPESSOA_MENU', 'RECADVIEW_MENU'],
        }
      },
      {
        path: "formacao-academica",
        name: "RECADVIEW_FORMACAO_ACADEMICA_VIEW",
        component: () => import("@/paginas/recadastramentoView/formacaoAcademica.vue"),
        meta: {
          auth: ['GESTAOPESSOA_MENU', 'RECADVIEW_MENU'],
        }
      },
      {
        path: "dependentes",
        name: "RECADVIEW_DEPENDENTES_VIEW",
        component: () => import("@/paginas/recadastramentoView/dependentes.vue"),
        meta: {
          auth: ['GESTAOPESSOA_MENU', 'RECADVIEW_MENU'],
        }
      },
      {
        path: "capacitacao",
        name: "RECADVIEW_CAPACITACAO_VIEW",
        component: () => import("@/paginas/recadastramentoView/capacitacao.vue"),
        meta: {
          auth: ['GESTAOPESSOA_MENU', 'RECADVIEW_MENU'],
        }
      },
      {
        path: "experiencia-profissional",
        name: "RECADVIEW_EXPERIENCIA_PROFISSIONAL_VIEW",
        component: () =>
          import("@/paginas/recadastramentoView/experiencia-profissional.vue"),
        meta: {
          auth: ['GESTAOPESSOA_MENU', 'RECADVIEW_MENU'],
        }
      },
      {
        path: "vinculos",
        name: "RECADVIEW_VINCULOS_VIEW",
        component: () => import("@/paginas/recadastramentoView/vinculos.vue"),
        meta: {
          auth: ['GESTAOPESSOA_MENU', 'RECADVIEW_MENU'],
        }
      },
    ],
  }
]
